<h1 mat-dialog-title>About</h1>

<mat-dialog-content class="!text-xl">
  <table>
    <tr>
      <td class="pr-2 text-right"><strong>User:</strong></td>
      <td class="text-left" notranslate>{{ userName }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Employee ID:</strong></td>
      <td class="text-left" notranslate>{{ employeeNumber }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Home Cost Center:</strong></td>
      <td class="text-left" notranslate>{{ homeCostCenter }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Version:</strong></td>
      <td class="text-left" notranslate>{{ appVersion }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Environment:</strong></td>
      <td class="text-left" notranslate>{{ envName }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Device Type:</strong></td>
      <td class="text-left" notranslate>{{ deviceType }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>LogRocket URL:</strong></td>
      <td class="text-left" notranslate>
        <input type="text" class="w-100" readonly [value]="logRocketURLSubject$ | async" (click)="selectLogRocketUrl($event)" />
      </td>
    </tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="button" (click)="clearLocalStorageAndReload()">Clear Local Storage</button>
</mat-dialog-actions>
